import { fetchFactory } from 'isotope-client'

export const envoyerContact = (params) => fetchFactory(`/contactForm/submit`, {
	method: 'POST',
	body: JSON.stringify(params)
})